export const mockedTravelInsuranceResponse = {
  insurance: [
    {
      search_product_result_id: 'e0df0cc4-e350-41a4-bfbc-b2fe5d6d1578',
      product_code: 'travel-insurance',
      inventory_provider: 'internal',
      inventory_id: '33108-230645',
      inventory_item: {
        images: [
          {
            src: 'https://cdn.inventory.test.product.cavu-tech.com/images/1061-33108_ed98feb7-8cf0-4575-848e-77a33cdb749c.jpg',
            description: 'Travel insurance',
          },
        ],
        visiting_duration: null,
        upgrade: null,
        accreditations: [],
        baggage_type: null,
        meal_type: null,
        description: '<p>Travel insurance is essential for protecting your trip. It covers unexpected events like trip cancellations, medical emergencies, and lost luggage. Ensure peace of mind with comprehensive coverage tailored to your needs.</p>',
        overview: '<ul><li>- Global product availability based on country of residence</li><li>- 24/7 travel assistance and claims powered by Robin Assist</li><li>- Customer care rating (94%)</li><li>- Quick, fully digital claims experience</li></ul>',
        provider: 'Battleface originally launched in the UK and Europe for adventure travelers seeking travel insurance and assistance services in unique destinations. As more travelers became aware of battleface, we evolved alongside them to provide policies to fit their specific needs.<br><br>Our service oriented approach and “travel insurance shouldn’t be a battle” resonated in the UK and Europe and quickly grew across the world to the United States, Australia, and Canada. <br><br>battleface was built different from the start and continues to innovate and offer a new approach to travel medical insurance and assistance services. Because battleface is more than just insurance; we make your safety our priority as you experience the world. Battleface originally launched in the UK and Europe for adventure travelers seeking travel insurance and assistance services in unique destinations. As more travelers became aware of battleface, we evolved alongside them to provide policies to fit their specific needs.<br><br>',
        additional_fields: {
          zipcode: {
            is_required: false,
            is_show: true,
          },
          inbound_flight_number: {
            is_required: false,
            is_show: true,
          },
          phone_number: {
            is_required: false,
            is_show: true,
          },
          plate_number: {
            is_required: false,
            is_show: true,
          },
          outbound_flight_number: {
            is_required: false,
            is_show: true,
          },
        },
        airline_name: null,
        product_option: {
          name: 'Regular Travel Insurance',
          code: 'travel_insurance_regular',
        },
        entrance_info: "",
        product_logo: {
          src: null,
        },
        capacity: {
          left: 500,
          message_threshold: null,
        },
        entry_date: '2025-06-27T15:00:00',
        features: [
          "Covers trip cancellations",
            "Includes medical emergencies",
        ],
        name: 'Regular Travel Insurance',
        visiting_duration_message: null,
        logo: {
          src: 'https://www.battleface.com/wp-content/uploads/2023/03/battleface-logo-black.svg', //temporary link to official logo
          description: null,
        },
        exit_date: '2025-06-27T16:00:00',
        pii_questions: {
          order_management: null,
          payment: null,
        },
        is_featured: false,
        direction: null,
      },
      details: {
        visiting_duration: null,
        baggage_type: null,
        meal_type: null,
        visiting_duration_message: null,
        exit_date: '2025-06-27T16:00:00',
        airline_name: null,
        entry_date: '2025-06-27T15:00:00',
        direction: null,
      },
      inventory_options: [
        {
          fees: [],
          meta: {
            product_option_code: 'travel_insurance_regular',
            direction: null,
          },
          cancellation_policies: [
            {
              title: 'Cancellation Policy',
              message:
                'Free cancellation',
            },
          ],
          taxes: [
            {
              name: 'Sales Tax',
              amount: 1.5,
              id: 79437,
            },
          ],
          amendment_policies: [
            {
              title: 'Amendment Policy',
              message:
                'Free amendment up to 3 days',
            },
          ],
          details: {
            duration: 60,
            groups: {
              senior: {
                is_selected: false,
              },
              adult: {
                age: {
                  min: 16,
                },
                is_selected: true,
                totals: {
                  single_total: 10,
                  subtotal: 10,
                  quantity: 1,
                },
              },
              infant: {
                is_selected: false,
              },
              child: {
                age: {
                  max: 16,
                  min: 0,
                },
                is_selected: true,
              },
            },
            cancellation_protection: {
              cancellation_policies: [
                {
                  title: 'Cancellation Policy',
                  message:
                    'Free cancellation up to 24 hours',
                },
              ],
              taxes: [
                {
                  name: 'Sales Tax',
                  type: 'additional',
                  amount: 0.1,
                },
              ],
              totals: {
                taxes: 0.1,
                total: 1.1,
                fees: 0,
                channel_based: {
                  total: 1,
                },
                subtotal: 1,
              },
              message:
                'For just £1.00 you can cancel.',
              is_available: true,
            },
            is_parent: true,
          },
          sub_options: [

          ],
          id: 230625,
          totals: {
            fees: 0,
            total: 11.5,
            quantity: 1,
            subtotal: 10,
            bundle_saving: 0,
            discount: 0,
            taxes: 1.5,
            currency: 'GBP',
            exchange: null,
            channel_based: {
              total: 10,
              total_discounted: 10,
            },
          },
          is_available: true,
        },
      ],
    },
  ],
};
